export const PROMISE_SETTLED_STATUS = ["fulfilled", "rejected"] as const;
export type TPromiseSettledStatus = (typeof PROMISE_SETTLED_STATUS)[number];
export const PROMISE_SETTLED_STATUS_OBJ = {
  FULFILLED: "fulfilled",
  REJECTED: "rejected",
} as const satisfies Record<string, TPromiseSettledStatus>;

export const UPSTREAM_ERROR_CODE = "UPSTREAM_ERROR" as const;
